export const getPages = (state, payload) => {
  if (!payload.total_records) return state.pages;

  return Math.ceil(payload.total_records / payload.per_page);
};
